// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statisticBlock__m8BVg {
  padding: 0 25px;
  display: flex;
  column-gap: 40px;
  height: 45px;
  align-items: center;
}

.statisticTitle__XeLQo {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  white-space: nowrap;
}
@media (max-width: 1275px) {
  .statisticTitle__XeLQo {
    line-height: 12px;
  }
}

.statisticValueBlock__PbhtR {
  display: flex;
  column-gap: 10px;
  line-height: 12px;
}
@media (max-width: 1275px) {
  .statisticValueBlock__PbhtR {
    flex-direction: column;
    row-gap: 10px;
  }
}

.statisticValue__LANXd {
  font-size: 12px;
  font-weight: 700;
  color: var(--header-title-secondary);
  white-space: nowrap;
}

.statisticType__qK4jW {
  font-size: 11px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
}

.skeletonText__K6fkw {
  width: 50px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/Archive/components/ArchiveStatistic/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,eAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AAzEF;;AA2EA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,yCAAA;EACA,mBAAA;AAxEF;AA0EE;EAPF;IAQI,iBAAA;EAvEF;AACF;;AA0EA;EACE,aAAA;EACA,gBAAA;EACA,iBAAA;AAvEF;AAyEE;EALF;IAMI,sBAAA;IACA,aAAA;EAtEF;AACF;;AAyEA;EACE,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,mBAAA;AAtEF;;AAyEA;EACE,eAAA;EACA,yBAAA;EACA,yCAAA;EAjEA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EA8DA,qBAAA;EACA,aAAA;AAjEF;;AAoEA;EACE,WAAA;AAjEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.statisticBlock {\n  padding: 0 25px;\n  display: flex;\n  column-gap: 40px;\n  height: 45px;\n  align-items: center;\n}\n.statisticTitle {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  white-space: nowrap;\n\n  @media (max-width: 1275px) {\n    line-height: 12px;\n  }\n}\n\n.statisticValueBlock {\n  display: flex;\n  column-gap: 10px;\n  line-height: 12px;\n\n  @media (max-width: 1275px) {\n    flex-direction: column;\n    row-gap: 10px;\n  }\n}\n\n.statisticValue {\n  font-size: 12px;\n  font-weight: 700;\n  color: var( --header-title-secondary);\n  white-space: nowrap;\n}\n\n.statisticType {\n  font-size: 11px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  @include ellipsis-text;\n  -webkit-line-clamp: 1;\n  line-clamp: 1;\n}\n\n.skeletonText {\n  width: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statisticBlock": `statisticBlock__m8BVg`,
	"statisticTitle": `statisticTitle__XeLQo`,
	"statisticValueBlock": `statisticValueBlock__PbhtR`,
	"statisticValue": `statisticValue__LANXd`,
	"statisticType": `statisticType__qK4jW`,
	"skeletonText": `skeletonText__K6fkw`
};
module.exports = ___CSS_LOADER_EXPORT___;
